// extracted by mini-css-extract-plugin
export var dividerLine = "_3m-0";
export var errorBackground = "_3m-1";